// @flow
import SearchUrlFormatter from './formatters/SearchUrlFormatter';
import type {SearchRequest} from './models/SearchRequest';
import petSyncer from './utils/petSyncer';
import generateUrl from './utils/generateUrl';
import type {SyncWithStrategy} from './utils/petSyncer';

export const ROOT_PATH = '/search';

export type Root = typeof ROOT_PATH;

type Options = {
    /**
     * Strategy to use for syncing the pet refinements with petIncluded trip data.
     * Defaults to 'both'
     */
    petSyncStrategy?: SyncWithStrategy,
    /**
     * Returns absolute URL using value of this property as the hostname if it exists
     */
    hostname?: string,

    /**
     * Turns off canonical keyword transform
     */
    canonicalizeKeywords?: boolean
};

/**
 * Generates a search URL for the given Search Request model
 *
 * @param searchRequest - Search Request model
 * @param options
 * @returns {string} - relative url
 */
export default function toURL(
    searchRequest: SearchRequest,
    options: Options = {}
): string {
    const {hostname} = options;
    // sync pets
    searchRequest = petSyncer(searchRequest, options.petSyncStrategy);

    const {canonicalizeKeywords} = {canonicalizeKeywords: true, ...options};

    const formattedSearchUrl: string = new SearchUrlFormatter().format(
        searchRequest,
        {canonicalizeKeywords}
    );

    return generateUrl(hostname, formattedSearchUrl);
}
